import { Controller } from "@hotwired/stimulus";

// GO4TEACH lot 24 « Animer la classe »: the timer — a preset (1 to 15 minutes), start / pause,
// reset; « Temps écoulé » when it ends. Counts from the clock, not from the ticks: a tab in the
// background does not slow it down.
const pad = (value) => String(value).padStart(2, "0");

export default class extends Controller {
  static targets = ["display", "toggle"];
  static values = { done: String };

  connect() {
    this.total = 5 * 60;
    this.left = this.total;
    this.endsAt = null;
    this.show();
  }

  disconnect() {
    this.stop();
  }

  preset(event) {
    this.stop();
    this.total = parseInt(event.currentTarget.dataset.minutes, 10) * 60;
    this.left = this.total;
    this.finished = false;
    this.show();
  }

  toggle() {
    if (this.endsAt) {
      this.left = this.remaining();
      this.stop();
    } else if (this.left > 0) {
      this.endsAt = Date.now() + this.left * 1000;
      this.tick = window.setInterval(() => this.show(), 250);
    }
    this.show();
  }

  reset() {
    this.stop();
    this.left = this.total;
    this.finished = false;
    this.show();
  }

  stop() {
    if (this.tick) window.clearInterval(this.tick);
    this.tick = null;
    this.endsAt = null;
  }

  remaining() {
    return this.endsAt ? Math.max(0, Math.round((this.endsAt - Date.now()) / 1000)) : this.left;
  }

  show() {
    const left = this.remaining();
    if (this.endsAt && left === 0) {
      this.stop();
      this.left = 0;
      this.finished = true;
    }
    this.displayTarget.textContent = this.finished ? this.doneValue : `${pad(Math.floor(left / 60))}:${pad(left % 60)}`;
    const toggle = this.toggleTarget;
    toggle.textContent = this.endsAt ? toggle.dataset.pauseLabel : toggle.dataset.startLabel;
  }
}
